import app from './app/reducer'
import user from './user/reducer'
import members from './members/reducer'
import language from './language/reducer'

export default { app, user, members, language }
